/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Who_QInputs */

const en_wc_faq_who_q = /** @type {(inputs: Wc_Faq_Who_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who makes WordCraft? Is this the official site?`)
};

/**
* | output |
* | --- |
* | "Who makes WordCraft? Is this the official site?" |
*
* @param {Wc_Faq_Who_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_who_q = /** @type {((inputs?: Wc_Faq_Who_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Who_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_who_q(inputs)
});
export { wc_faq_who_q as "wc.faq.who.q" }